module.exports = __webpack_public_path__ + "static/media/add-lead-icon.9d3fdf52.svg";